import React, { useState, useEffect } from 'react';
import {
  Typography,
  Row,
  Col,
  Radio,
  Tooltip,
  Form,
  Skeleton,
  Input,
  notification,
  DatePicker,
  Card,
  Divider,
  Collapse,
  Modal,
  Space,
  Alert,
  Popconfirm,
  Checkbox,
} from 'antd';
import {
  CheckOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import dayjs from 'dayjs';

import BreadcrumbContainer from '../../containers/Breadcrumb';
import INTERNAL_LINKS from '../../enums/InternalLinks';

import {
  get,
  organizationSelector,
  post,
  postDocument,
  projectSelector,
  put,
  putDocument,
  postFile,
  deleteFile,
  filesTable,
  assignFile,
  downloadFile,
  generatePublicLink,
  launch,
  invitationsTable,
  removeInvitation,
} from '../../api/module/announcement';

import { catchExceptionSRate } from '../../utils/helpers/helpers';
import { AjaxTable, CustomButton, CustomSelector } from '../../components';
import BetterUpload from '../../components/BetterUpload';
import { useHistory } from 'react-router-dom';
import MESSAGES from '../../enums/Messages';
import CustomUpload from '../../components/CustomUpload';
import { Link } from 'react-router-dom';
import {
  ajaxTable as roleTable,
  remove as removeRole,
} from '../../api/module/announcement_rol';

const { Title, Paragraph } = Typography;

const breadcrumbItems = [
  {
    text: 'Convocatoria',
    to: `${INTERNAL_LINKS.ANNOUNCEMENT}`,
  },
  {
    text: 'Crear Convocatoria',
  },
];

const breadcrumbItemsEdit = [
  {
    text: 'Convocatoria',
    to: `${INTERNAL_LINKS.ANNOUNCEMENT}`,
  },
  {
    text: 'Convocatorias en curso',
    to: `${INTERNAL_LINKS.ANNOUNCEMENT_PROGRESS}`,
  },
  {
    text: 'Editar Convocatoria',
  },
];

const UserMassiveUpload = ({
  announcementID,
  pendingMassive,
  setPendingMassive,
  setReloadInvitations,
}) => {
  const [loading, setLoading] = useState(false);
  const [loadingFile, setLoadingFile] = useState(undefined);
  const [reloadFiles, setReloadFiles] = useState(false);

  const [uploadForm] = Form.useForm();

  const assignMassive = async (id) => {
    try {
      setLoadingFile(1);
      await assignFile(id);
      setLoadingFile();
      setPendingMassive();
      setReloadFiles({});
      setReloadInvitations({});
    } catch (error) {
      setLoadingFile();
      catchExceptionSRate(error, MESSAGES.DESC_ERROR_POST_MSG);
    }
  };

  const deleteMassive = async (id) => {
    try {
      setLoadingFile(2);
      await deleteFile(id);
      setLoadingFile();
      setPendingMassive();
      setReloadFiles({});
    } catch (error) {
      setLoadingFile();
      catchExceptionSRate(error, MESSAGES.DESC_ERROR_POST_MSG);
    }
  };

  const uploadMassive = async (data) => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('archivo', data.fileList[0].originFileObj);
      formData.append('convocatoria', announcementID);
      const res = await postFile(formData);
      setPendingMassive(res.data.id);
      setLoading(false);
      setReloadFiles({});
    } catch (error) {
      setLoading(false);
      catchExceptionSRate(error, MESSAGES.DESC_ERROR_POST_MSG);
    }
  };

  const downloadMassive = async (id) => {
    try {
      setLoadingFile(3);
      let response = await downloadFile(id);
      const file = new Blob([response.data], {
        type: 'application/vnd.ms-excel',
      });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL, '_blank');
      setLoadingFile();
    } catch (error) {
      setLoadingFile();
      catchExceptionSRate(error, MESSAGES.DESC_ERROR_POST_MSG);
    }
  };

  const filesColumns = [
    {
      title: 'Nombre del archivo',
      dataIndex: 'nombre',
      align: 'center',
    },
    {
      title: 'Fecha y hora cargue',
      dataIndex: 'created_at',
      render: (d) => dayjs(d).format('YYYY-MM-DD hh:mm'),
      align: 'center',
    },
    {
      title: 'Cantidad total de registros',
      dataIndex: 'registros',
      width: '8rem',
      align: 'center',
    },
    {
      title: 'Registros aprobados',
      dataIndex: 'aprobados',
      width: '8rem',
      align: 'center',
    },
    {
      title: 'Registros con errores',
      dataIndex: 'con_error',
      width: '8rem',
      align: 'center',
    },
    {
      title: 'Archivo revisado',
      key: 'download',
      width: '8rem',
      align: 'center',
      render: (_, record) => (
        <CustomButton
          text="Revisar"
          danger
          type="default"
          htmlType="button"
          onClick={() => downloadMassive(record.id)}
          loading={3 === loadingFile}
          disabled={loadingFile}
        />
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      align: 'center',
      render: (_, record) =>
        record.asignado ? (
          <CustomButton
            type="default"
            htmlType="button"
            block
            text={
              <>
                <CheckOutlined /> <strong> Datos ya cargados </strong>
              </>
            }
          />
        ) : (
          <Space>
            {record.aprobados === record.registros && (
              <CustomButton
                text="Asignar registros aprobados"
                htmlType="button"
                onClick={() => assignMassive(record.id)}
                loading={1 === loadingFile}
                disabled={loadingFile}
              />
            )}
            <CustomButton
              text="Eliminar archivo"
              danger
              type="default"
              htmlType="button"
              onClick={() => deleteMassive(record.id)}
              loading={2 === loadingFile}
              disabled={loadingFile}
            />
          </Space>
        ),
    },
  ];
  return (
    <>
      <Paragraph>
        Descargue{' '}
        <a
          href={`${process.env.REACT_APP_API_DOMAIN}/static/download/Plantilla_Usuarios_Externos.xlsx`}
          target="_blank"
          rel="noreferrer"
        >
          aquí
        </a>{' '}
        la plantilla y diligencie la información solicitada.
      </Paragraph>
      <br />
      <Form
        form={uploadForm}
        onFinish={(e) => uploadMassive(e.archivo)}
        layout="vertical"
      >
        <CustomUpload
          file_type={3}
          upload_type={2}
          name="archivo"
          label="Seleccione el archivo Excel diligenciado a partir de la plantilla sugerida"
          buttonLabel="Seleccionar archivo a cargar"
          loading={loading}
          disabled={loadingFile || pendingMassive}
          required
        />
        <CustomButton
          loading={loading}
          disabled={loadingFile || pendingMassive}
          text="Cargar y verificar archivo"
          htmlType="button"
          onClick={() => uploadForm.submit()}
        />
      </Form>
      <br />
      <Alert
        showIcon
        message="TENGA EN CUENTA"
        description="No puede cargar un nuevo archivo cuando aún tienen un archivo en trámite o pendiente de gestionar (Eliminar/Cargar)"
      />
      <br />
      {!loading && (
        <AjaxTable
          tableTitle="Listado de archivos cargados"
          endpoint={filesTable}
          query={announcementID}
          columns={filesColumns}
          reloadSource={reloadFiles}
          pageSize={3}
        />
      )}
    </>
  );
};

export default function AnnouncementForm({ match }) {
  const navigate = useHistory();

  const [announcementID] = useState(match.params.announcement_id);

  const [loading, setLoading] = useState(false);
  const [initialValues, setInitialValues] = useState(null);
  const [loadingLink, setLoadingLink] = useState(false);

  const [reloadRolesSource, setReloadRolesSource] = useState(false);
  const [deleteRoleID, setDeleteRoleID] = useState();

  const [reloadInvitationsSource, setReloadInvitationsSource] = useState(false);
  const [deleteInvitationID, setDeleteInvitationID] = useState();
  const [isSendInvitations, setIsSendInvitations] = useState(false);

  const [form] = Form.useForm();

  useEffect(() => {
    handleGet();
  }, []);

  const handleGet = async () => {
    if (!announcementID) {
      return;
    }
    try {
      const { data: resData } = await get(announcementID);
      setInitialValues({
        ...resData,
        fecha_inicio: resData.fecha_inicio
          ? dayjs(resData.fecha_inicio)
          : undefined,
        fecha_fin: resData.fecha_fin ? dayjs(resData.fecha_fin) : undefined,
        usuarios_siga: !!resData.usuarios_siga,
        usuarios_externos: !!resData.usuarios_externos || resData.has_any_file,
      });
    } catch (err) {
      catchExceptionSRate(err);
    }
  };

  const projectSelectorWithOther = async () => {
    const { data: resData } = await projectSelector();
    return {
      data: {
        results: [
          {
            value: 0,
            label: 'Otro...',
          },
          ...resData.results,
        ],
      },
    };
  };

  const save = async (data, raiseError = false) => {
    try {
      setLoading(true);
      let response;

      data.fecha_inicio = dayjs(data.fecha_inicio).format('YYYY-MM-DD');
      data.fecha_fin = dayjs(data.fecha_fin).format('YYYY-MM-DD');

      if (data.anexo !== null) {
        const formData = new FormData();
        formData.append('anexo', data);
        for (let prop in data) {
          if (data.hasOwnProperty(prop)) formData.append(prop, data[prop]);
        }

        if (announcementID) {
          response = await putDocument(initialValues.id, formData);
        } else {
          response = await postDocument(formData);
        }
      } else {
        if (announcementID) {
          response = await put(initialValues.id, data);
        } else {
          response = await post(data);
        }
      }

      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_MSG,
        duration: 2,
      });
      if (!announcementID) {
        setTimeout(() => {
          setLoading(false);
          navigate.push(
            `${INTERNAL_LINKS.ANNOUNCEMENT_FORM}/${response.data.id}`,
          );
        }, MESSAGES.TIME);
      } else {
        setLoading(false);
      }
    } catch (err) {
      catchExceptionSRate(err);
      setLoading(false);
      if (raiseError) {
        throw err;
      }
    }
  };

  const usersCollapseItems = [
    {
      key: '1',
      label:
        'Cargar usuarios externos / referenciados y/o usuarios ya registrados',
      children: (
        <UserMassiveUpload
          announcementID={announcementID}
          pendingMassive={initialValues?.has_pending_file}
          setPendingMassive={(v) =>
            setInitialValues((s) => ({ ...s, has_pending_file: v }))
          }
          setReloadInvitations={setReloadInvitationsSource}
        />
      ),
    },
  ];

  const onGeneratePublicLink = async () => {
    try {
      setLoadingLink(true);
      const { data: resData } = await generatePublicLink(announcementID);
      setInitialValues((s) => ({ ...s, link_publico: resData.link_publico }));
      setLoadingLink(false);
    } catch (error) {
      setLoadingLink(false);
      catchExceptionSRate(error);
    }
  };

  const sendInvitations = async () => {
    setIsSendInvitations(true);

    try {
      const formValues = await form.validateFields();
      await save(formValues, true);
    } catch (error) {
      setIsSendInvitations(false);
      return;
    }
    try {
      await launch(announcementID);
      let secondsToGo = 5;
      const modal = Modal.success({
        title: MESSAGES.SUCCESS_MSG,
        content: (
          <>
            <p>{MESSAGES.DESC_SUCCESS_SEND_INVITATIONS_MSG}</p>
            <p>Esta solicitud tardará en terminarse</p>
          </>
        ),
        onOk: () => navigate.push(`${INTERNAL_LINKS.ANNOUNCEMENT}`),
      });
      setTimeout(() => {
        modal.destroy();
        navigate.push(`${INTERNAL_LINKS.ANNOUNCEMENT}`);
      }, secondsToGo * 1000);
      setIsSendInvitations(false);
    } catch (err) {
      catchExceptionSRate(err, MESSAGES.DESC_ERROR_SEND_INVITATIONS_MSG);
      setIsSendInvitations(false);
    }
  };

  const deleteDataSource = async (id) => {
    try {
      setDeleteInvitationID(id);
      await removeInvitation(id);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_DELETE_MSG,
        duration: 2,
      });
      setReloadInvitationsSource({});
    } catch (err) {
      catchExceptionSRate(err, MESSAGES.DESC_ERROR_DELETE_MSG);
    } finally {
      setDeleteInvitationID();
    }
  };

  const deleteRole = async (id) => {
    try {
      setDeleteRoleID(id);
      await removeRole(id);
      notification.success({
        message: MESSAGES.SUCCESS_MSG,
        description: MESSAGES.DESC_SUCCESS_DELETE_MSG,
        duration: 2,
      });
      setReloadRolesSource({});
      setDeleteRoleID();
    } catch (err) {
      catchExceptionSRate(err, MESSAGES.DESC_ERROR_DELETE_MSG);
    }
  };

  const columns = [
    {
      title: 'Nombres y Apellidos',
      dataIndex: 'nombre_completo',
    },
    {
      title: 'Sigla y Nro. doc',
      dataIndex: 'identificacion',
    },
    {
      title: 'Lugar residencia',
      dataIndex: 'lugar_residencia',
    },
    {
      title: 'Acciones',
      dataIndex: 'Acciones',
      fixed: 'right',
      width: 120,
      render: (_, record) => (
        <CustomButton
          danger
          type={'default'}
          htmlType="button"
          disabled={!!deleteInvitationID}
          loading={deleteInvitationID === record.id}
          text={
            <Popconfirm
              title={MESSAGES.DELETE_CONFIRM_MSG}
              onConfirm={() => deleteDataSource(record.id)}
            >
              Eliminar
            </Popconfirm>
          }
        />
      ),
    },
  ];

  return (
    <>
      {announcementID ? (
        <BreadcrumbContainer items={breadcrumbItemsEdit} />
      ) : (
        <BreadcrumbContainer items={breadcrumbItems} />
      )}
      <Title className={'text-uppercase'} level={2}>
        {announcementID ? 'Editar convocatoria' : 'Crear convocatoria'}
      </Title>
      {announcementID && !initialValues ? (
        <Skeleton loading active />
      ) : (
        <Form
          form={form}
          layout="vertical"
          scrollToFirstError
          onFinish={save}
          initialValues={initialValues}
        >
          <Row gutter={12}>
            <Col span={12}>
              <Form.Item
                name="clase"
                label="Clase de convocatoria"
                rules={[
                  {
                    required: true,
                    message:
                      'Es requerido que seleccione una clase de convocatoria',
                  },
                ]}
              >
                <Radio.Group>
                  <Radio value={true}>Convocatoria regular</Radio>
                  <Radio style={{ marginRight: '13px' }} value={false}>
                    Convocatoria tipo ICFES
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="tipo"
                label="Tipo de convocatoria"
                rules={[
                  {
                    required: true,
                    message:
                      'Es requerido que seleccione una clase de convocatoria',
                  },
                ]}
              >
                <Radio.Group>
                  <Radio value={true}>Abierta</Radio>
                  <Radio style={{ marginRight: '13px' }} value={false}>
                    Cerrada{' '}
                    <Tooltip title="Es para proyecto existente">
                      <QuestionCircleOutlined style={{ color: '#8c8c8c' }} />
                    </Tooltip>
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="organizacion"
                label="Organización ejecutora"
                rules={[
                  {
                    required: true,
                  },
                ]}
                valuePropName="initialValue"
              >
                <CustomSelector
                  selectorProps={{
                    style: { width: '100%' },
                    placeholder: 'Seleccione la organización...',
                  }}
                  endpointFetch={organizationSelector}
                />
              </Form.Item>
            </Col>
            <Form.Item noStyle dependencies={['tipo']}>
              {({ getFieldValue }) => {
                const announcementType = getFieldValue('tipo');
                return announcementType === true ? (
                  <Col span={12}>
                    <Form.Item
                      name="proyecto_nombre"
                      label="Proyecto, licitación, concurso u otro"
                      rules={[
                        {
                          required: true,
                        },
                        () => ({
                          validator(_, value) {
                            if (!value || value.length <= 100) {
                              return Promise.resolve();
                            }
                            return Promise.reject(
                              'Solo puede ingresar 100 caracteres!',
                            );
                          },
                        }),
                      ]}
                    >
                      <Input
                        style={{ marginLeft: '5px' }}
                        placeholder="Nombre de proyecto, licitación, concurso u otro..."
                        allowClear
                      />
                    </Form.Item>
                  </Col>
                ) : announcementType === false ? (
                  <>
                    <Col span={12}>
                      <Form.Item
                        name="proyecto"
                        label="Proyecto"
                        rules={[
                          {
                            required: true,
                          },
                        ]}
                        valuePropName="initialValue"
                      >
                        <CustomSelector
                          selectorProps={{
                            style: { width: '100%' },
                            placeholder: 'Seleccione el proyecto...',
                          }}
                          endpointFetch={projectSelectorWithOther}
                        />
                      </Form.Item>
                    </Col>
                    <Form.Item noStyle dependencies={['proyecto']}>
                      {({ getFieldValue }) =>
                        getFieldValue('proyecto') === 0 ? (
                          <Col span={24}>
                            <Form.Item
                              name="proyecto_nombre"
                              label="Nombre del proyecto, licitación, concurso u otro"
                              rules={[
                                {
                                  required: true,
                                },
                                () => ({
                                  validator(_, value) {
                                    if (!value || value.length <= 100) {
                                      return Promise.resolve();
                                    }
                                    return Promise.reject(
                                      'Solo puede ingresar 100 caracteres!',
                                    );
                                  },
                                }),
                              ]}
                            >
                              <Input
                                style={{ marginLeft: '5px' }}
                                placeholder="Nombre de proyecto, licitación, concurso u otro..."
                                allowClear
                              />
                            </Form.Item>
                          </Col>
                        ) : null
                      }
                    </Form.Item>
                  </>
                ) : null;
              }}
            </Form.Item>
          </Row>
          <Row gutter={12}>
            <Col span={6}>
              <Form.Item
                name="numero"
                label="Número de convocatoria"
                tooltip={{
                  placement: 'top',
                  title: `Una vez guarde la convocatoria, automáticamente se generará el número de convocatoria.`,
                }}
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={18}>
              <Form.Item
                name="nombre"
                label="Nombre de la convocatoria"
                rules={[
                  {
                    required: true,
                  },
                  () => ({
                    validator(_, value) {
                      if (!value || value.length <= 100) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        'Solo puede ingresar 100 caracteres!',
                      );
                    },
                  }),
                ]}
              >
                <Input placeholder="Nombre de la convocatoria..." allowClear />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                style={{ marginBottom: 10 }}
                name="fecha_inicio"
                label="Fecha de inicio de la convocatoria"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  disabled={initialValues?.convocatoria_lanzada}
                  placeholder="Fecha inicio..."
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
              <Form.Item noStyle dependencies={['fecha_inicio']}>
                {({ getFieldValue }) =>
                  getFieldValue('fecha_inicio') ? (
                    <Form.Item noStyle>
                      Fecha de inicio seleccionada:
                      <strong>
                        {' '}
                        {getFieldValue('fecha_inicio').format('DD MMMM YYYY')}
                      </strong>
                    </Form.Item>
                  ) : null
                }
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item noStyle dependencies={['fecha_inicio']}>
                {({ getFieldValue }) => {
                  const fi = getFieldValue('fecha_inicio');

                  function disabledDate(current) {
                    // Can not select days before fecha_inicio, or if launched, fecha_fin
                    return (
                      current &&
                      current <
                        (initialValues?.convocatoria_lanzada
                          ? initialValues.fecha_fin
                          : fi)
                    );
                  }
                  return (
                    <Form.Item
                      style={{ marginBottom: 10 }}
                      name="fecha_fin"
                      label="Fecha de finalización de la convocatoria"
                      rules={[
                        {
                          required: true,
                        },
                        ({ getFieldValue }) => ({
                          validator(_, value) {
                            if (
                              getFieldValue('fecha_inicio') != null &&
                              getFieldValue('fecha_fin') != null
                            ) {
                              if (
                                getFieldValue('fecha_inicio').isAfter(
                                  value,
                                  'day',
                                )
                              ) {
                                return Promise.reject(
                                  new Error(
                                    'La fecha de fin no puede ser menor a la fecha de inicio',
                                  ),
                                );
                              } else {
                                return Promise.resolve();
                              }
                            } else {
                              return Promise.resolve();
                            }
                          },
                        }),
                      ]}
                    >
                      <DatePicker
                        disabledDate={disabledDate}
                        placeholder="Fecha fin..."
                        style={{ width: '100%' }}
                        format="YYYY-MM-DD"
                        disabled={!fi}
                      />
                    </Form.Item>
                  );
                }}
              </Form.Item>
              <Form.Item noStyle dependencies={['fecha_fin']}>
                {({ getFieldValue }) =>
                  getFieldValue('fecha_fin') ? (
                    <Form.Item noStyle>
                      Fecha de finalización seleccionada:
                      <strong>
                        {' '}
                        {getFieldValue('fecha_fin').format('DD MMMM YYYY')}
                      </strong>
                    </Form.Item>
                  ) : null
                }
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="anexo" label="Cargue archivo anexo convocatoria">
                <BetterUpload
                  fileType="pdf"
                  showUploadList={{ showRemoveIcon: false }}
                  listType={'text'}
                  existingText="Anexo_Convocatoria.pdf"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={12} style={{ marginTop: 20 }}>
            <Col span={24}>
              <Form.Item
                name="aliado_nombre"
                label="Aliado para el cual se requiere esta convocatoria (no es visible para externos)"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder="Nombre del aliado..." allowClear />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                name="descripcion"
                label="Descripción de la convocatoria"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input.TextArea
                  rows={5}
                  placeholder="Descripción de la convocatoria..."
                  allowClear
                />
              </Form.Item>
            </Col>
          </Row>
          <Row justify={'center'}>
            <CustomButton
              loading={loading}
              htmlType="submit"
              text="Guardar convocatoria"
            />
          </Row>
          {!!announcementID && initialValues ? (
            <>
              <CustomButton
                disabled={initialValues?.convocatoria_lanzada}
                style={{ marginTop: 10 }}
                type={'default'}
                className={'ant-btn-info'}
                htmlType="button"
                onClick={() =>
                  navigate.push(
                    `${INTERNAL_LINKS.ANNOUNCEMENT_POSITION}/${announcementID}`,
                  )
                }
                text={
                  <>
                    <PlusOutlined /> Agregar Cargo/Rol
                  </>
                }
              />
              <AjaxTable
                tableTitle="Listado de Cargo/Rol para la convocatoria"
                endpoint={roleTable}
                query={{ convocatoria: announcementID }}
                columns={[
                  {
                    title: 'Cargo',
                    dataIndex: 'cargo',
                  },
                  {
                    title: 'Tiempo contrato',
                    dataIndex: 'duracion',
                    render: (_, record) =>
                      `${record?.duracion || 'No especificado'} (${record?.unidad_tiempo_texto || 'No especificado'})`,
                  },
                  {
                    title: 'Total vacantes',
                    dataIndex: 'total_vacantes',
                    align: 'right',
                  },
                  {
                    title: 'ACCIÓN',
                    dataIndex: 'accion',
                    align: 'center',
                    width: 200,
                    render: (_, record) => (
                      <Space>
                        {!initialValues?.convocatoria_lanzada ? (
                          <>
                            <CustomButton
                              type={'default'}
                              className={'ant-btn-info'}
                              htmlType="button"
                              text={
                                <Link
                                  to={`${INTERNAL_LINKS.ANNOUNCEMENT_POSITION}/${record.convocatoria}/${record.id}/`}
                                >
                                  Editar
                                </Link>
                              }
                            />
                            <CustomButton
                              type={'default'}
                              htmlType="button"
                              danger
                              disabled={!!deleteRoleID}
                              loading={deleteRoleID === record.id}
                              text={
                                <Popconfirm
                                  title={MESSAGES.DELETE_CONFIRM_MSG}
                                  onConfirm={() => deleteRole(record.id)}
                                >
                                  Eliminar
                                </Popconfirm>
                              }
                            />
                          </>
                        ) : (
                          <Paragraph>
                            No hay acciones disponibles porque la convocatoria
                            ya fue lanzada.
                          </Paragraph>
                        )}
                      </Space>
                    ),
                  },
                ]}
                reloadSource={reloadRolesSource}
              />
            </>
          ) : null}

          {!!announcementID && initialValues ? (
            <>
              <Card
                size={'small'}
                bordered={false}
                title={<Title level={3}>Agregar usuarios</Title>}
              >
                <Form.Item noStyle dependencies={['tipo']}>
                  {({ getFieldValue }) =>
                    getFieldValue('tipo') ? (
                      <>
                        <Paragraph>¿A quién va dirigida?</Paragraph>
                        <Row gutter={12}>
                          <Col span={12}>
                            <Form.Item
                              name="usuarios_siga"
                              rules={[
                                {
                                  validator(_, value) {
                                    if (
                                      !value &&
                                      !!!form.getFieldValue('usuarios_externos')
                                    )
                                      return Promise.reject(
                                        new Error('Campo requerido'),
                                      );
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                              dependencies={['usuarios_externos']}
                              valuePropName="checked"
                            >
                              <Checkbox>
                                Todos los usuarios registrados en SIGA
                              </Checkbox>
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              name="usuarios_externos"
                              rules={[
                                {
                                  validator(_, value) {
                                    if (
                                      !value &&
                                      !!!form.getFieldValue('usuarios_siga')
                                    )
                                      return Promise.reject(
                                        new Error('Campo requerido'),
                                      );
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                              dependencies={['usuarios_siga']}
                              valuePropName="checked"
                            >
                              <Checkbox disabled={initialValues?.has_any_file}>
                                Usuarios Externos / Referenciados
                              </Checkbox>
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    ) : null
                  }
                </Form.Item>
              </Card>
              <Form.Item noStyle dependencies={['usuarios_externos', 'tipo']}>
                {({ getFieldValue }) =>
                  getFieldValue('usuarios_externos') ||
                  getFieldValue('tipo') === false ? (
                    <>
                      <Divider>Opción 1.</Divider>
                      <Collapse
                        defaultActiveKey={['1']}
                        items={usersCollapseItems}
                      />
                    </>
                  ) : null
                }
              </Form.Item>
              <AjaxTable
                query={announcementID}
                columns={columns}
                rowKey="id"
                tableTitle="Listado de Contratistas agregados"
                reloadSource={reloadInvitationsSource}
                endpoint={invitationsTable}
                searchInput
              />
              <Form.Item noStyle dependencies={['tipo']}>
                {({ getFieldValue }) =>
                  getFieldValue('tipo') === true ? (
                    <>
                      <Card
                        size={'small'}
                        bordered={false}
                        title={
                          <Title level={3}>
                            Información de la convocatoria
                          </Title>
                        }
                      >
                        <Alert
                          style={{ marginTop: '10px' }}
                          type="info"
                          showIcon
                          action={
                            <CustomButton
                              type="default"
                              className={'back-button'}
                              text="Generar Link convocatoria"
                              onClick={onGeneratePublicLink}
                              htmlType="button"
                            />
                          }
                          description="Si desea compartir esta convocatoria con usuarios NO registrados en SIGA, ni referenciados, a través de redes y otras plataformas, genere el link, cópielo y péguelo donde lo requiera. El contenido del link generado será visible una vez sea lanzada la convocatoria"
                          message={'Información'}
                        />
                        {loadingLink ? (
                          <Skeleton loading active />
                        ) : (
                          <Paragraph
                            code
                            copyable={
                              initialValues?.link_publico
                                ? {
                                    text: `${process.env.REACT_APP_HOST}${INTERNAL_LINKS.PUBLIC_ANNOUNCEMENT}/${initialValues.link_publico}`,
                                    tooltips: ['Copiar link', 'Copiado!'],
                                  }
                                : false
                            }
                            style={{
                              display: 'inline-flex',
                              alignItems: 'center',
                              gap: '8px',
                              padding: '4px 8px',
                              margin: 0,
                            }}
                          >
                            {initialValues?.link_publico
                              ? `${process.env.REACT_APP_HOST}${INTERNAL_LINKS.PUBLIC_ANNOUNCEMENT}/${initialValues.link_publico}`
                              : 'Link no generado'}
                          </Paragraph>
                        )}
                      </Card>
                    </>
                  ) : null
                }
              </Form.Item>
              <Row gutter={12}>
                <Col span={12}>
                  <Space>
                    <CustomButton
                      text="Guardar convocatoria"
                      loading={loading}
                      onClick={() => form.submit()}
                    />
                    <CustomButton
                      type={'default'}
                      className={'back-button'}
                      htmlType="button"
                      text={
                        <Link to={`${INTERNAL_LINKS.ANNOUNCEMENT_PROGRESS}`}>
                          Volver
                        </Link>
                      }
                    />
                  </Space>
                </Col>
                <Col span={12}>
                  <Space>
                    <CustomButton
                      type="default"
                      className={'ant-btn-info'}
                      htmlType="button"
                      text={
                        <Link
                          to={`${INTERNAL_LINKS.ANNOUNCEMENT_SHOW}/${announcementID}?preview=true`}
                        >
                          Visualizar convocatoria
                        </Link>
                      }
                    />
                    {!initialValues.convocatoria_lanzada &&
                    initialValues.num_cargos > 0 ? (
                      <Popconfirm
                        placement="topLeft"
                        title="¿Está seguro(a) que los datos registrados en la convocatoria están correctos?"
                        okText="Sí"
                        cancelText="No"
                        onConfirm={sendInvitations}
                      >
                        <CustomButton
                          type="default"
                          text="Lanzar Convocatoria"
                          htmlType="button"
                          loading={isSendInvitations}
                        />
                      </Popconfirm>
                    ) : null}
                  </Space>
                </Col>
              </Row>
            </>
          ) : null}
        </Form>
      )}
    </>
  );
}
